import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { SubReservationApiModel } from '@rocksoft/inroom-sdk';
import { isNotUndefined } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { selectCurrentMobileReservation } from '../../../stores/mobilereservation/mobilereservation.selector';

@Component({
  selector: 'era-reservation-summary',
  templateUrl: './reservation-summary.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, DatePipe],
})
export class ReservationSummaryContainerComponent {
  private readonly store = inject(Store);

  public readonly reservation$: Observable<SubReservationApiModel>;

  constructor() {
    this.reservation$ = this.store.select(selectCurrentMobileReservation).pipe(
      map((x) => x?.SubReservations?.[0]),
      filter(isNotUndefined)
    );
  }
}
